export default "<mat-checkbox [(ngModel)]=\"checked\" (change)=\"onChange($event)\" disableRipple>{{label}}</mat-checkbox>\n";